import React, { useState, forwardRef, useImperativeHandle } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import TextEditor from "../Frequents/TextEditor.js";
import SelectBoolean from "../Frequents/SelectBoolean.js";
import { set } from "../../actions";
import update from "immutability-helper";

const NewFollowUp = forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);
    const [followUpText, setFollowUpText] = useState("");
    const [followUpTime, setFollowUpTime] = useState("");
    const [followUpActive, setFollowUpActive] = useState("");
    const [type, setType] = useState("");

    const dispatch = useDispatch();
    const therapist = useSelector(state => state.data.therapist);

    const handleSave = async () => {
        if(type === 'kursus'){
            await dispatch(
                set({
                    therapist: update(therapist, {
                        followUpTextCourse: { $set: followUpText },
                        followUpTimeCourse: { $set: followUpTime },
                        followUpCourse: { $set: followUpActive }
                    })
                })
            );
        }else{
            await dispatch(
                set({
                    therapist: update(therapist, {
                        followUpText: { $set: followUpText },
                        followUpTime: { $set: followUpTime },
                        followUp: { $set: followUpActive }
                    })
                })
            );
        }
        setOpen(false);
    };

    useImperativeHandle(ref, () => ({
        editFollowUp(text, time, active,type) {
            setOpen(true);
            setFollowUpText(text);
            setFollowUpTime(time);
            setFollowUpActive(active);
            setType(type);
        }
    }));

    return (
        <div>
            {props.new ? (
                <Button
                    onClick={() => setOpen(true)}
                    style={{ backgroundColor: "#343434", color: "#fff", float: "right" }}
                    variant="contained"
                    startIcon={<AddCircleIcon />}>
                    Ny skabelon
                </Button>
            ) : null}
            <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="form-dialog-title" maxWidth="lg">
                <DialogTitle id="form-dialog-title">Ny Opfølgningsbesked</DialogTitle>
                <DialogContent>
                    <DialogContentText>Indstillinger for opfølgningsbeskeden.</DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="daysAfter"
                        label="Modtagelsestidspunkt i dage efter behandling"
                        type="number"
                        value={followUpTime}
                        onChange={event => setFollowUpTime(event.target.value)}
                        fullWidth
                    />
                    <SelectBoolean
                        text="Tilvalg af denne service"
                        prop={followUpActive}
                        choice1="Ja"
                        choice2="Nej"
                        value1={true}
                        value2={false}
                        changeValue={setFollowUpActive}
                    />
                    <TextEditor value={followUpText} onChange={setFollowUpText} />
                    <DialogContentText style={{ fontSize: "10px" }}>
                        Alle beskeder vil begynde med "Hej (klientes Fornavn)".
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary">
                        Luk
                    </Button>
                    <Button onClick={handleSave} color="primary">
                        Gem
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
});
export default NewFollowUp;
